import {React, useState} from 'react';
import { 
    TextField, 
    Button, 
    Typography, 
    IconButton, 
    Dialog, 
    DialogContent, 
    DialogTitle,
    Snackbar,
    Alert,
    Box,
} from '@mui/material';
import emailjs from 'emailjs-com';
import CloseIcon from '@mui/icons-material/Close';
import {useMapContext} from "../../../contexts/MapContext";


const FeedbackPage = ({ open, onClose }) => {
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const {
      userData,
    } = useMapContext();

    const handleSubmit = (e) => {
        e.preventDefault();
        const email = userData.email;

        if (!email.trim()) {
            setStatus('Email is required.');
            return;
        }



        emailjs.send(
            'serv_SewerTycoonDetroit',
            'template_bnv7ax8',
            { 
                from_name: email,
                message: message, 
                reply_to: email 
            },
            'oH7oHiZnEgJer7b6j'
        )
        .then(() => {
            setStatus('Feedback sent successfully!');
            setSnackbarOpen(true);
            setMessage('');
            setTimeout(() => {
                handleDialogClose();
            }, 1000);
        })
        .catch(() => {
            setStatus('Failed to send feedback. Please try again.');
        });
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const handleDialogClose = () => {
        setStatus('');
        onClose();
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="md"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: '#1a1a1a',
                        color: '#ffffff',
                        borderRadius: 2,
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: 3,
                        pb: 2,
                        '& + .MuiDialogContent-root': {
                            paddingTop: 2
                        }
                    }}
                >
                    <Typography variant="h6" sx={{ 
                        fontWeight: 500, 
                        color: '#fff',
                        fontFamily: 'Helvetica, Arial, sans-serif'
                    }}>
                        Send Us Your Feedback
                    </Typography>
                    <IconButton 
                        onClick={handleDialogClose} 
                        sx={{ 
                            color: '#fff',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.1)'
                            }
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ padding: 3, pt: 2 }}>
                    <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <Typography variant="body1" sx={{ color: '#ccc' }}>
                            We'd love to hear your thoughts about SewerTycoon. Your feedback helps us improve the application. Let us know what you're thinking and we'll do our best to address it.
                        </Typography>
                        <TextField
                            placeholder="What's on your mind?"
                            variant="outlined"
                            multiline
                            rows={8}
                            fullWidth
                            required
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    backgroundColor: '#2a2a2a',
                                    color: '#fff',
                                    '& fieldset': {
                                        borderColor: '#444',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#666',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#90caf9',
                                    },
                                },
                            }}
                        />
                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                            <Button
                                variant="outlined"
                                onClick={handleDialogClose}
                                sx={{
                                    color: '#90caf9',
                                    borderColor: '#90caf9',
                                    '&:hover': {
                                        borderColor: '#90caf9',
                                        backgroundColor: 'rgba(144, 202, 249, 0.08)',
                                    },
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                type="submit"
                                disabled={!message.trim()} // Disabled if email or message is empty
                                sx={{
                                    backgroundColor: message.trim() ? '#90caf9' : '#666',
                                    color: message.trim() ? '#000' : '#ccc',
                                    '&:hover': {
                                        backgroundColor: message.trim() ? '#42a5f5' : '#666',
                                    },
                                }}
                            >
                                Send Feedback
                            </Button>
                        </Box>
                        {status && (
                            <Typography
                                variant="body2"
                                sx={{
                                    color: status.includes('successfully') ? '#4caf50' : '#f44336',
                                    textAlign: 'center',
                                }}
                            >
                                {status}
                            </Typography>
                        )}
                    </Box>
                </DialogContent>
            </Dialog>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert 
                    onClose={handleSnackbarClose} 
                    severity="success" 
                    sx={{ 
                        width: '100%',
                        backgroundColor: '#1e4620',
                        color: '#fff',
                        '& .MuiAlert-icon': {
                            color: '#4caf50'
                        }
                    }}
                >
                    Thank you for your feedback! We'll review it soon.
                </Alert>
            </Snackbar>
        </>
    );
};

export default FeedbackPage;
